export const GET_APPEAL_APPLICATION_RECORDS = '/registrations';
export const GET_APPEAL_FEES = '/appeal-fee';
export const GET_AVAILABLE_RESULTS = '/exam-levels';
export const GET_APPEAL_LISTING = '/appeal-listing';
export const POST_APPEAL_DRAFT = '/draft/save';
export const GET_APPEAL_DRAFT_REVIEW = '/review';
export const GET_APPEAL_RECEIPT = '/candidate/transaction-info';
export const GET_APPEAL_RECEIPT_SUMMARY = '/receipt/summary';
export const GET_APPEAL_CANDIDATE_DOWNLOAD_SUMMARY = `/candidate/receipt/download`;
export const POST_APPEAL_TO_PAYMENT = `/save`;
export const POST_CHECK_ELIGIBILITY = `/check-eligibility`;
